// 常駐活動置底按鈕
'use client';
import { useSelector, useDispatch } from 'react-redux';
import { setLoginModal, setCampaignSpinModal, setCampaignRecordModal } from '@/slices/popSlice';
import { userState } from '@/slices/userSlice';
import dayjs from 'dayjs';

const CampaignFixedButtons = ({ device, endTime }) => {
    console.log(endTime);
    const dispatch = useDispatch();
    const { user } = useSelector(userState);

    const showLogin = () => dispatch(setLoginModal(true));

    // 點擊中獎紀錄
    const onClickRecord = () => {
        if (!user?.uid) showLogin();
        // 顯示中獎紀錄彈窗
        else dispatch(setCampaignRecordModal(true));
    };

    // 進行遊戲
    const onSpin = () => {
        if (!user?.uid) showLogin();
        // 顯示輪盤
        else dispatch(setCampaignSpinModal(true));
    };

    return (
        // 桌機版 sticky
        // 手機版 fixed
        <div
            className={`${
                device === 'pc'
                    ? 'flex sticky max-w-[905px] ulg:hidden mx-auto [&>button]:border-1'
                    : 'hidden fixed w-screen left-0 ulg:flex h-[58px] [&>button]:border-t-1'
            } bottom-[-1px] z-[5] items-center
                [&>button]:text-[#fff] [&>button]:trans [&>button]:text-btn1 [&>button]:py-[20px] [&>button]:backdrop-blur-[5px]
                 [&>button]:border-[#fff] [&>button]:border-opacity-[.3] [&>button]:text-center`}
        >
            <button
                onClick={onClickRecord}
                className="flex-grow max-w-[268px] bg-[#123C57] bg-opacity-[.86] hover:bg-[#246895]"
            >
                {user?.uid ? '我的中獎紀錄' : '登入查看中獎紀錄'}
            </button>
            <button
                onClick={onSpin}
                disabled={dayjs().isAfter(endTime)}
                className={`flex-grow  
                ${
                    dayjs().isAfter(endTime)
                        ? 'bg-[#9B9B9B] cursor-not-allowed'
                        : 'bg-opacity-[.8] bg-[#1BBDE0] hover:bg-[#008798] hover:bg-opacity-[.84]'
                }`}
            >
                {dayjs().isAfter(endTime) ? '活動已結束' : '開啟輪盤獲取抽獎券'}
            </button>
        </div>
    );
};

export default CampaignFixedButtons;
